import request from '@/utils/request'
export const listCoupons=params=>request({url:'/dkmall/coupons',method:'get',params})
export const getCoupon=id=>request({url:`/dkmall/coupons/${id}`,method:'get'})
export const addCoupon=data=>request({url:'/dkmall/coupons',method:'post',data})
export const editCoupon=data=>request({url:'/dkmall/coupons',method:'put',data})
export const setCouponStatus=(id,status)=>request({url:`/dkmall/coupons/${id}/status`,method:'put',params:{status}})
export const removeCoupon=id=>request({url:`/dkmall/coupons/${id}`,method:'delete'})
export const listCouponRecords=params=>request({url:'/dkmall/coupons/records',method:'get',params})
export const deleteCouponRecords=data=>request({url:'/dkmall/coupons/records/batch',method:'delete',data})
export const couponScopeCategories=()=>request({url:'/dkmall/coupons/scope-categories',method:'get'})
export const couponScopeGoods=params=>request({url:'/dkmall/coupons/scope-goods',method:'get',params})
export const getCouponCenter=region=>request({url:`/dkmall/coupon-center/${region}`,method:'get'})
export const saveCouponCenter=(region,data)=>request({url:`/dkmall/coupon-center/${region}`,method:'put',data})
